import { render, staticRenderFns } from "./AddNewQuestionGroup.vue?vue&type=template&id=2fb065cb&"
import script from "./AddNewQuestionGroup.vue?vue&type=script&lang=js&"
export * from "./AddNewQuestionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports